import React from 'react';
import styled from 'styled-components';
import PhotoContestCard from './PhotoContestCard';

const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(6, 1fr);
	gap: 16px;

	@media (max-width: 1400px) {
		grid-template-columns: repeat(4, 1fr);
	}

	@media (max-width: 1024px) {
		grid-template-columns: repeat(3, 1fr);
	}

	@media (max-width: 640px) {
		grid-template-columns: repeat(2, 1fr);
	}
`;

export default function PhotoContestGrid({ submissions, onCardClick }) {
	return (
		<Grid>
			{submissions.map((submission) => (
				<PhotoContestCard
					key={submission.id}
					submission={submission}
					onClick={onCardClick}
				/>
			))}
		</Grid>
	);
}
